const commands = Object.create(null)

export function registerCommand(action: string, handler: (data: object) => void) {
  commands[action] = handler
}

export default function invoke({
  reqId,
  request: {
    action,
    data
  }
}) {
  if (commands[action]) {
    commands[action]({
      reqId,
      ...data
    })
  } else {
    console.error(action + ' is undefined')
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/bridge/invoke.ts